import { HighAvailability } from '@redislabsdev/cloud-ui-databases-types';

export const getHighAvailabilityStatus = (plan: Plan): HighAvailability => {
  if (plan.is_multi_az) {
    return 'multiZone';
  }

  if (plan.replication !== 'default') {
    return 'singleZone';
  }

  return 'noReplica';
};
